import type { ReactNode } from 'react';
import type { IconComponent } from '../../types';
import { CdHeading, CdText } from '../../atoms/CdTypography';
import { cx } from '../../utils';
import styles from './CdCalloutBanner.module.scss';

export interface CdCalloutBannerProps {
  icon?: IconComponent;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/** Bordered strip with icon, copy and a trailing action ("Already applied? · View my applications"). */
export const CdCalloutBanner = ({
  icon: Icon,
  title,
  description,
  action,
  className,
}: CdCalloutBannerProps) => {
  return (
    <section className={cx(styles.root, className)}>
      {Icon && <Icon className={styles.icon} size={32} aria-hidden="true" />}
      <div className={styles.body}>
        <CdHeading level={2} size="lg">
          {title}
        </CdHeading>
        {description && <CdText tone="secondary">{description}</CdText>}
      </div>
      {action && <div className={styles.action}>{action}</div>}
    </section>
  );
};
